<template>
	<div 
		class="regionItem"
		:style="`--color-uaqi-level: var(--color-uaqi-${region.level})`"
		tabindex="0"
		role="button"
	>
		<div class="regionName">
			<div>
				<h2 style="margin: 0px;">{{ region.name.replace(" область", "") }}</h2>
				<small>Всього встановлено {{ getStationWord(region.installed_stations) }}</small>
			</div>
		</div>
		<div class="regionPollutantsList">
			<div
				v-for="v in regionPollutants"
				:key="v.type"
				class="regionPollutant"
			>
				<span>{{ v.type }}</span>
				<h3>{{ v.value != null ? v.value.toFixed(1) : "-" }}</h3>
				<small>{{ v.unit }}</small>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed, defineProps } from 'vue'

import { getStationWord } from '@/modules/Language.js'

const props = defineProps({
	region: {
		type: Object,
		required: true
	}
})

const regionPollutants = computed(() => {
	if (!props.region.pollutants) return []

	// TODO: Server should return pollutants in correct order
	return ["PM10", "PM2.5", "NO₂", "CO", "CH₂O"].map(type => {
		const pollutant = props.region.pollutants.find(p => p.type == type)
		return {
			type: type,
			value: pollutant ? pollutant.value : null,
			unit: pollutant ? pollutant.unit : null
		}
	})
})
</script>

<style scoped>
.regionItem {
	display: flex;
	flex-direction: row;

	background-color: var(--color-background);

	padding: 15px;

	border-radius: 15px;

	overflow: hidden;

	user-select: none;
	cursor: pointer;

	border: 1px solid color-mix(in lab, var(--color-uaqi-level), #0000 20%);

	/* box-shadow: inset 0 0px 30px v-bin + 20); */

	transition: background-color 0.3s ease-in-out,
				box-shadow 0.5s ease-in-out,
				translate 0.3s ease-out;
}

.regionItem:hover {
	background-color: color-mix(in lab, var(--color-uaqi-level), #0000 75%);;
	box-shadow: 0 2px 10px var(--color-bg);
	translate: 0 -5px;
}

.regionName {
	flex-grow: 1;

	margin: -15px;
	padding: 20px;
	padding-left: 20px;

	display: flex;
	align-items: center;

	background: linear-gradient(to right, color-mix(in lab, var(--color-uaqi-level), #0000 75%), #00000000);
}

/* Make block vertical */
@media only screen and (max-width: 700px) {
	.regionItem {
		flex-direction: column;
	}

	.regionName {
		background: linear-gradient(color-mix(in lab, var(--color-uaqi-level), #0000 75%), #00000000);
	}
}

.regionPollutantsList {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.regionPollutant {
	display: flex;
	flex-direction: column;
	align-items: center;

	width: 4.0em;

	padding: 10px 10px;
}

@media only screen and (max-width: 520px) {
	.regionPollutant:last-child {
		/* display: none !important; */
	}	
}

.regionPollutant > h3 {
	margin: 0.2em;
}
</style>